import { EditVehiclePanel } from "@/components/organisms";

export const EditVehicle = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <EditVehiclePanel />
    </div>
  );
};
